module.exports = __webpack_public_path__ + "static/media/synth-success.174e3088.mp3";